module.exports = __webpack_public_path__ + "static/media/Conductor.38853eea.png";